import { Container, Box, Typography, SpeedDial, SpeedDialAction, SpeedDialIcon, ButtonGroup, Button } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import ListComponent from '../components/ListComponent'
import { useNavigate } from 'react-router'
import AddIcon from '@mui/icons-material/Add'
import { useMediaQuery } from '@mui/material'
import FilterInsumoComponent from '../components/FilterInsumoComponent'
import ListMasiveComponent from '../components/ListMasiveComponent'
import { useUtiles } from '../../../../shared/context/utilesContext'
import { FilterList as FilterListIcon, Upload as UploadIcon } from '@mui/icons-material'
import { useAbility } from '../../../../shared/context/AbilityContext'
import { useEffect } from 'react'

export default function ListIsumosView() {
    const theme = useTheme()
    const navigate = useNavigate()
    const isMobile = useMediaQuery('(max-width: 600px)')
    const { toogleOpenSilder } = useUtiles()

    //verificar si el usuario tiene permisos para ver el listado de insumos
    const ability = useAbility();
    useEffect(() => {
        if (!ability.can('read', 'RESOURCES')) {
            navigate('/')
        }
    }, [ability])


    return (
        <Container maxWidth="xl" disableGutters sx={{
            padding: '0px', margin: '0px',
        }}>
            <Box sx={{
                borderRadius: '10px',
                backgroundColor: theme.palette.background.paper,
                padding: '10px 20px',
                position: 'relative'
            }}>
                <Typography variant="h6" sx={{
                    fontWeight: 'bold',
                    marginBottom: '10px',
                    fontSize: '20px',
                }}>
                    Lista de Insumos
                </Typography>

                <Box sx={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                    alignItems: 'center'
                }}>

                    {!isMobile && (
                        <ButtonGroup>
                            <Button startIcon={<FilterListIcon />} onClick={() => toogleOpenSilder(<FilterInsumoComponent />, 400, 'Filtros')}>
                                Filtros
                            </Button>
                            {ability.can('create', 'RESOURCES') && (
                                <Button startIcon={<UploadIcon />} onClick={() => toogleOpenSilder(<ListMasiveComponent />, 600, 'Cargar Masivo')}>
                                    Importar
                                </Button>
                            )} 
                        </ButtonGroup>)}

                    {isMobile && (
                        <Button startIcon={<FilterListIcon />} onClick={() => toogleOpenSilder(<FilterInsumoComponent />, 600, 'Filtros')} variant="outlined">
                            Filtros
                        </Button>
                    )}
                </Box>

                <ListComponent />

                {ability.can('create', 'RESOURCES') && (
                    <SpeedDial
                        ariaLabel="Add"
                        sx={{ position: 'absolute', bottom: isMobile ? 80 : 30, right: 8 }}
                        icon={<AddIcon />}
                        direction="right"
                        openIcon={<AddIcon />}
                        onClick={() => navigate('/insumos/crear')}
                    />
                )}
            </Box>
        </Container>
    )
}